import { AfterViewInit, Component, HostListener, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { GlobalService } from 'src/app/services/global.service';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { Subject, takeUntil } from 'rxjs';
import { NotificationsService } from '../notifications-center/notifications.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { Location } from '@angular/common';
import { fadeInOutWithBlur } from 'src/app/core/global-app-animations';
import { SidebarComponent } from '../sidebar/sidebar.component';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [fadeInOutWithBlur,
        trigger('slideDownUp', [
            transition(':enter', [
                style({ overflow: 'hidden', opacity: 0 }),
                animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 1 })),
            ]),
            transition(':leave', [
                style({ overflow: 'hidden', opacity: 1 }),
                animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @ViewChild('navside') public sidebar!: SidebarComponent
  @Input() sidebarOpen: any;
  titolo: string = ''
  getScreenWidth: number = 0;
  getScreenHeight: number = 0;
  connectionStatus: boolean = true;

  toRead: number = 0;

  showNotifs: boolean = false;

  theEnd$ = new Subject<void>();

  currentUrl: string = '';

  constructor
    (
      private globalService: GlobalService,
      private localstorageService: LocalStorageService,
      private router: Router,
      private browserD: BrowserDetectorService,
      private notifications: NotificationsService,
      private location: Location
    ) {


    this.router.events.pipe(takeUntil(this.theEnd$)).subscribe(event => this.currentUrl = this.router.url);
  }

  // if the user press 'esc' close the notification component
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    //console.warn(event);
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.closeNotification();
    }

  }

  closeNotification() {
    if (this.showNotifs == true) {
      this.showNotifs = false;
      this.blockScroll();
    }
  }

  ngOnInit(): void {

    this.toRead = this.notifications.getNotificationsToRead();

    this.localstorageService.watchTitle().subscribe((data: string) => {
      this.titolo = this.localstorageService.getTitolo();
    });

    this.browserD.connectionStatus$.pipe(takeUntil(this.theEnd$)).subscribe((val: boolean) => {
      this.connectionStatus = val;
    })

    this.notifications.updateNotificationsSubject$.pipe(takeUntil(this.theEnd$)).subscribe((val: number) => {
      //console.log(val)
      this.toRead = val;
    })


  }


  togSide() {
    this.globalService.closeSidebar.next();
  }

  goToNotif() {
    this.router.navigate(['home/notifications'])
  }

  blockScroll() {
    //console.log("\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n")
    //console.log(document.getElementById('global-content-container')?.classList)
    if (this.showNotifs) {
      document.getElementById('global-content-container')?.classList.add('overflow-hidden', 'fixed', 'w-screen')
    } else {
      document.getElementById('global-content-container')?.classList.remove('overflow-hidden', 'fixed', 'w-screen')
    }
  }

  back() {
    this.location.back();
  }



}
